var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-area"},[_c('aside',[_c('h'+_vm.level,{tag:"div",staticClass:"link-area-heading"},[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"wrap"},[_c('ul',{staticClass:"link-area-list"},[_vm._t("default")],2)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }